import dayjs from 'dayjs'
import { useTranslation } from 'react-i18next'

import { Link } from 'features/i18n/router'
import { useLinger } from 'hooks'
import { Review } from 'lib/_types'
import { logEvent, snowplowEvent } from 'lib/analytics'
import { ROUTE_PATH } from 'lib/paths'
import { fromNowToFullDate } from 'lib/time'
import { useCurrentUser } from 'store/api/yay/user'

import Avatar from '../Avatar'
import Menu from '../Menu'
import Pinned from '../Pinned'

import './style.scss'

export type ReviewExtended = Review & {
  deletable: boolean
  pinnable: boolean
  pinned: boolean
}

export const UserReviewItem = ({
  index,
  review,
  menu,
  setUserWarningId,
  isSelfUserReview,
}: {
  index: number
  review: ReviewExtended
  menu: Array<{
    title: string
    onClick: () => void
  }>
  setUserWarningId: Function
  isSelfUserReview: boolean
}) => {
  const { t } = useTranslation()
  const { data: currentUser } = useCurrentUser()

  const { inViewRef } = useLinger({
    enterCallback: (params) => {
      if (params.first_impression) {
        snowplowEvent.impression({
          letter: {
            sender_id: isSelfUserReview
              ? review?.reviewer?.id
              : currentUser?.id,
            receiver_id: review?.user?.id,
          },
        })
      }
    },
  })

  return (
    <div className="UserReview__item" data-x={review} ref={inViewRef}>
      {review.pinned && <Pinned text={t('user_review_list.pinned_review')} />}

      <div className="UserReview__item__profile">
        <Link
          onClick={() =>
            logEvent.user_profile_open({
              target_user_id: review?.reviewer?.id?.toString?.(),
              from: 'undefined',
            })
          }
          to={ROUTE_PATH.USER(review?.reviewer?.id)}
          className="UserReview__item__profile__wrapper"
        >
          <Avatar
            user={review?.reviewer}
            wrapperClassName="UserReview__item__profile__avatar"
          />
          <dt>{review?.reviewer?.nickname}</dt>

          {(review?.reviewer?.recently_kenta ||
            review?.reviewer?.dangerous_user) && (
            <div
              className="UserReview__item__profile__warning_icon"
              onClick={(e) => {
                e.preventDefault()
                setUserWarningId(review?.reviewer?.id ?? null)
              }}
              role="button"
            />
          )}
        </Link>

        <time
          className="UserReview__item__time"
          title={dayjs(review?.created_at * 1000).format()}
        >
          {fromNowToFullDate(review?.created_at * 1000)}
        </time>
      </div>

      <div className="UserReview__item__body">
        <dd>{review?.comment}</dd>

        {currentUser && menu.length > 0 && (
          <Menu
            options={menu}
            icon="3dots-v"
            arrowPosition="right"
            panelPosition={index ? 'left' : 'left-down'}
          />
        )}
      </div>
    </div>
  )
}
